export const DEMO_FUNCTION_TOOLTIP = 'Функция недоступна в демо режиме';
